import type { FromRouteState } from './useLocationState';

/**
 * Build router state with `fromRoute` for navigation. Inverse of `useLocationState`.
 */
export const buildLocationState = <T extends object = Record<never, never>>(
  fromRoute: string,
  state?: T,
): T & FromRouteState => ({ ...state, fromRoute }) as T & FromRouteState;
